import { useState } from "react";

import { Box, Drawer, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import '../../css/searchPage.css'

import { UseGetFlag } from "../../app/launchDarkly";
import { setSortMode } from "../../app/search/search.slice";
import { clearSearchFilters, sortRecipes } from "../../app/search/search.thunk";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import { TextPrimary } from "../typography";

const Sort = ({ drawerOpen, setSortDrawer }: { drawerOpen: any, setSortDrawer: any }) => {
	const filterArray = {
		filterArrayValues: [
			{ value: 'ascending', label: 'A-Z' },
			{ value: 'time', label: 'Time low to high' },
			{ value: 'recommended', label: 'Recommended' },
		],
		button1: 'Clear all',
		button2: 'Sort'
	}
	const sortMode = useAppSelector((state) => state.search.sortMode);
	const user = useAppSelector((state) => state.main.user);
	const [selected, setSelected] = useState<any>(sortMode)
	const { userSettings } = { ...user };
	const { enableAdminFeatures, recipeOrdering } = UseGetFlag()
	const dispatch = useAppDispatch();

	const handleClose = () => {
		setSortDrawer(false)
	}
	const clearFilter = () => {
		dispatch(clearSearchFilters(enableAdminFeatures));
		setSelected([])
		handleClose();
	}

	const applyFilter = () => {
		dispatch(sortRecipes(selected, recipeOrdering));
		handleClose();
	}
	const menuSelection = () => {
		dispatch(setSortMode(selected));
		applyFilter()
	}

	return (
		<Drawer
			anchor='bottom'
			className='filterDrawer'
			onClose={() => setSortDrawer(false)}
			open={drawerOpen}
			style={{ borderRadius: '20px 20px 0 0' }}>
			<Box sx={{ height: '70vh', backgroundColor: '#FCF8EA', position: 'relative' }}>
				<Box sx={{ m: 2, display: 'flex', flexDirection: 'column' }}>

					<Box sx={{ m: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
						<RadioGroup
							aria-labelledby="demo-radio-buttons-group-label"
							onChange={(event, value) => setSelected(value)}
							value={selected}
						>
							{filterArray?.filterArrayValues?.map((filterValue: any) => (
								<FormControlLabel control={<Radio />} label={<TextPrimary text={filterValue.label} />} value={filterValue.value} />
							))}
						</RadioGroup>
					</Box>
					<Box sx={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', bottom: 10, zIndex: 5, width: '90%' }}>
						<Box onClick={() => clearFilter()} sx={{ p: 2, color: '#FF0000', width: '40%', textAlign: 'center' }}>
							{filterArray?.button1}
						</Box>
						<Box onClick={() => menuSelection()} sx={{ p: 2, color: '#FFF', backgroundColor: '#3B1F8E', width: '40%', textAlign: 'center', borderRadius: '10px' }}>
							{filterArray?.button2}
						</Box>
					</Box>
				</Box>
			</Box>
		</Drawer>
	)
};

export default Sort;